



<div class="d-flex flex-wrap h-100 align-content-end align-items-baseline">
  <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <ul class="footerMnu align-self-end pl-0 mb-4">
      <li>
        <a (click) = "contactUs()">Contact us</a>
      </li>
      <li   *ngIf="parentRoute[0]?.path === 'current_business'">
        <a   (click)='Terms()'>Terms & Conditions</a>
      </li>
      <!-- <li >
        <a *ngIf="router.url != '/'">FAQ</a>
      </li> -->
      <!-- <li >
        <a *ngIf="router.url != '/'">Privacy Policy</a>
      </li> -->
      <li (click)='showVersions()'   *ngIf="parentRoute[0]?.path === 'current_business'">
        <a *ngIf="router.url != '/'">About</a>
      </li>
    </ul>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6" >
      <div class="d-flex align-items-center h-100">
        <div class="copyright text-center w-100">
          <p class="my-0  ">
            © {{year}} StandardC. All Rights Reserved
          </p>
        </div>
      </div>
    </div>
</div>
